import { render, staticRenderFns } from "./scenario-compare-tabs.vue?vue&type=template&id=5140d2b0&scoped=true"
import script from "./scenario-compare-tabs.vue?vue&type=script&lang=ts"
export * from "./scenario-compare-tabs.vue?vue&type=script&lang=ts"
import style0 from "./scenario-compare-tabs.vue?vue&type=style&index=0&id=5140d2b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140d2b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5140d2b0')) {
      api.createRecord('5140d2b0', component.options)
    } else {
      api.reload('5140d2b0', component.options)
    }
    module.hot.accept("./scenario-compare-tabs.vue?vue&type=template&id=5140d2b0&scoped=true", function () {
      api.rerender('5140d2b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/results/scenario-compare/sections/scenario-compare-tabs.vue"
export default component.exports